export default "__VITE_ASSET__Do3Yc7ba__"